export const auditLogReportColumns = [
  { key: 'actorDatetime', label: 'Date/Time' },
  { key: 'merchantName', label: 'Merchant' },
  { key: 'total', label: 'Total Amount' },
  { key: 'actor', label: 'User' },
  { key: 'fieldType', label: 'Activity' },
  { key: 'oldValue', label: 'Old Value' },
  { key: 'newValue', label: 'New Value' },
]
